export const LOGIN = '/login';
export const HOME = '/';
export const EMAIL_SIGNUP = '/email-signup';
export const FORGOT_PASSWORD = '/forgot-password';
export const DOWNLOADS = '/downloads';
export const REFERRALS = '/referrals';
export const UPCOMING = '/upcoming';
export const PDF = (file = ':file') => `/pdf/${file}`;




// WEBPACK FOOTER //
// ./src/urls.js